import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-goto-modal',
  templateUrl: './goto-modal.component.html',
  styleUrls: ['./goto-modal.component.scss'],
})
export class GotoModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalRef: MatDialogRef<GotoModalComponent>
  ) {}

  onOk() {
    if (this.data === 'popcorn') {
      window.open('https://www.popcorn.plus/home');
    } else if (this.data === 'jiegehao') {
      window.open('https://jiegehao.cn/home');
    }
    this.modalRef.close();
  }
}
